<template>
	<el-row>
		<el-col :span="24">
			<div class="base-form header">
				<h2 class="item" v-if="viewType == ViewType.Creating">
					Новая группа запчастей
				</h2>
				<h2 class="item" v-else>
					Карточка группы запчастей <span>{{ originItemGroup?.name }}</span>
				</h2>
			</div>
		</el-col>		
	</el-row>
	<el-row>
		<el-col :span="24" style="text-align: left;">
			<div class="base-form">
				<el-form class="base-form" :model="ruleForm" ref="jobForm" status-icon :rules="rules">
					<el-form-item label="Название" label-position="top" prop="name">
						<el-input v-model="ruleForm.name" maxlength="255" />
					</el-form-item>		

					<el-form-item label="Родительская группа" label-position="top">
						<tree-view-component 
							url="/api/itemsgroups"
							v-model="ruleForm.parentGroupId"
						/>
					</el-form-item>

					<el-form-item>
						<el-row style="width: 100%;">
							<el-col :span="5">
								<el-button type="primary" :disabled="isAsyncOperationPending" @click="onFormSubmitClick">
									{{ viewType == ViewType.Creating ? 'Создать' : 'Сохранить' }}
								</el-button>
							</el-col>
							<el-col :span="5">
								<el-button @click="onFormCancelClick">
									Отменить
								</el-button>
							</el-col>
							<el-col :span="14">
								<div v-if="viewType == ViewType.Editing" style="text-align: right;">
									<el-button type="danger" :disabled="isAsyncOperationPending" @click="onFormDeleteClick">
										Удалить сервисную работу
									</el-button>
								</div>
							</el-col>
						</el-row>
					</el-form-item>
				</el-form>
			</div>
		</el-col>
	</el-row>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import CatalogPickerComponent from '@/components/CatalogPickerComponent.vue';
import { ElButton, ElTable, ElLink, FormInstance, ElNotification, ElMessageBox } from 'element-plus';
import { reactive } from 'vue';
import axiosHelper from '@/helpers/axiosHelper';
import store from '@/store';
import TabsDictionary from '@/variables/tabs';
import EventHelper from '@/helpers/eventsHelper';
import ItemGroupModel from '@/models/ItemGroupModel';
import ViewType from '@/models/enums/ViewType';
import ItemsGroupApiHelper from '@/helpers/api/ItemsGroupApiHelper';
import LinkedLabelValuePair from '@/models/LinkedLabelValuePair';
import TreeViewComponent from '@/components/TreeViewComponent.vue';

interface IItemGroupFormFields {
	id: number;
	name: string;
	description: string | null;	
	parentGroupId: number | null
}

@Options({
	components: {
		ElButton, ElTable, ElLink, 
		CatalogPickerComponent,		
		TreeViewComponent
	},
	props: {
		params: Array
	}
})
export default class ItemsGroupView extends Vue {
	/** params */
	params!: Array<any>;

	/** constants */
	tabs = TabsDictionary;
	ViewType = ViewType;
	viewType: ViewType = this.ViewType.Viewing;
	refreshEvent = 'itemsGroupsUpdate';
	isJobExistHttpClient = axiosHelper.createInstance(store.getters.jwt);
	
	/** view-models */
	isAsyncOperationPending = false;
	originItemGroup: ItemGroupModel | null = null;
	itemsGroupsTree:  Array<LinkedLabelValuePair<string, number>> | null = null;	
	ruleForm = reactive<IItemGroupFormFields>({
		id: 0,
		name: '',
		description: null,
		parentGroupId: null
	});

	rules = reactive({
		name: [
			// { required: true, validator: async (a: any, b: any, c: any) => await this.serviceCategoryValidator(a,b,c), trigger: 'change'},
		],
		parentGroup: [
			// { required: true, validator: async (a: any, b: any, c: any) => await this.serviceOperationValidator(a,b,c), trigger: 'change'},
		]
	});

	mounted() {
		this.initForm();
	}

	/**
	 * init form with user's data from incoming parameters array (params)
	 */
	initForm() {
		if (!this.params?.length ||
			this.params.length < 2) {
			this.viewType = ViewType.Creating
			return;
		}

		this.viewType = this.params[1] as ViewType;

		if (this.viewType == ViewType.Viewing ||
			this.viewType == ViewType.Editing ||
			this.params[0]?.id) {
			this.originItemGroup = new ItemGroupModel(this.params[0]);
			this.ruleForm.id = this.originItemGroup.id;
			this.ruleForm.name = this.originItemGroup.name;
			this.ruleForm.parentGroupId = this.originItemGroup.parentGroupId;
			this.viewType = ViewType.Editing
		}
	}

	async onFormSubmitClick() {
		const form = this.$refs.jobForm as FormInstance;
		form.validate(async (valid) => {
			if (!valid) {
				return;
			}

			let result: boolean;
			this.isAsyncOperationPending = true;
			if (this.viewType == ViewType.Creating) {
				result = await this.addItemsGroup();
			} else {
				result = await this.updateItemsGroup();
			}

			if (result) {
				ElNotification({
					message: `Сервисная работа успешно ${this.viewType == ViewType.Creating ? 'создана' : 'обновлена'}`,
					type: 'success',
				});
				EventHelper.dispatchEvent('jobsUpdate');
				this.closeCurrentTab();
			} else {
				ElNotification({
					message: `Ошибка ${this.viewType == ViewType.Creating ? 'создания новой' : 'обновления'} группы запачастей`,
					type: 'error',
				});
			}

			this.isAsyncOperationPending = false;
		});
	}

	onFormCancelClick() {
		this.closeCurrentTab();
	}

	/** deletes an existing service-job */
	async onFormDeleteClick() {
		ElMessageBox.confirm(
			'Группа запчастей будет удалена', {
			confirmButtonText: 'OK',
			cancelButtonText: 'Отмена',
			type: 'error',
		})
		.then(async () => {
			try {
				this.isAsyncOperationPending = true;
				const apiHelper = new ItemsGroupApiHelper(store.getters.jwt);
				const isDeleted = await apiHelper.deleteGroupAsync(this.ruleForm.id);
				if (isDeleted) {
					EventHelper.dispatchEvent(this.refreshEvent);
					this.closeCurrentTab();	
				} else {
					ElNotification({
						title: 'Ошибка, работа не была удалена',
						type: 'error',
					});
				}				
				
			} finally {
				this.isAsyncOperationPending = false;
			}
		});
	}

	closeCurrentTab() {
		store.commit('removeTab', store.getters.tab);
	}

	/** post request for create a new group */
	async addItemsGroup() {
		const apiHelper = new ItemsGroupApiHelper(store.getters.jwt);
		return await apiHelper.addGroupAsync(
			this.ruleForm.name, 
			this.ruleForm.description, 
			this.ruleForm.parentGroupId);
	}

	/** put request for update an existing group */
	async updateItemsGroup() {
		const apiHelper = new ItemsGroupApiHelper(store.getters.jwt);
		return await apiHelper.updateGroupAsync(			
			this.ruleForm.id,
			this.ruleForm.name, 
			this.ruleForm.description, 
			this.ruleForm.parentGroupId
		);
	}

	async isGroupUnique(name: string, parentGroupId: number | null) : Promise<boolean> {
		const apiHelper = new ItemsGroupApiHelper(store.getters.jwt);
		return apiHelper.isGroupUniqueAsync(name, parentGroupId);
	}	
}
</script>
